import { Component } from '@verndale/core';

class AlertBanner extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults(): void {
    this.dom = {
      container: this.el as HTMLElement,
      triggers: this.el.querySelectorAll('.alert-banner__close-button')
    };
    this.checkIfBannerShouldBeClosed();
  }

  addListeners(): void {
    (this.dom.triggers as NodeList).forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );
  }

  handleClick() {
    this.el.remove();
    this.setBannerCookie();
  }

  checkIfBannerShouldBeClosed() {
    const cookieName = this.el.dataset.cookieName;
    const cookieExists = document.cookie
      .split(';')
      .some(item => item.trim().startsWith(`${cookieName}=`));

    if (cookieExists) this.el.remove();
  }

  setBannerCookie() {
    const cookieName = this.el.dataset.cookieName;
    const cookieMaxAge = this.el.dataset.cookieMaxAge;
    const alertBanner = this.el;
    alertBanner.remove();
    Array.from(alertBanner.querySelectorAll('a, button')).forEach(link => {
      link.setAttribute('tabindex', '0');
    });
    document.cookie = `${cookieName}=true; max-age=${cookieMaxAge}; path=/; SameSite=Strict`;
  }
}
export default AlertBanner;
